import React from 'react';
import { ButtonCont, HeaderCont, HeaderItem, JobText, Logo, MainHeader, TextCont } from './JobsHeader.styles';
import { CustomTypography } from 'shared/elements/CustomTypography';
import { CASTING_COM, CASTING_LOGO_TEXT, JOB_LOGO } from 'shared/constants/ASSETS_URL';
import { JOBS_SIDEBAR_ITEMS } from './JOBS_SIDEBAR_ITEMS';
import { COLORS } from 'shared/constants/COLORS';
import { Hidden, IconButton } from '@material-ui/core';
import { IoReorderThreeSharp } from 'react-icons/io5';
import { useContextSelector } from 'use-context-selector';
import { OpportunitiesContext } from 'pages/Opportunities/context/OpportunitiesContext';

const JobsHeader = () => {
  const shrink = useContextSelector(OpportunitiesContext, (state) => state.shrink);

  const goToLink = (path: string) => {
    window.location.href = path;
  };

  return (
    <HeaderCont shrink={shrink ? 1 : 0}>
      <MainHeader>
        <Logo src={CASTING_COM} />
        <React.Fragment>
          <Hidden smDown>
            <ButtonCont>
              {JOBS_SIDEBAR_ITEMS.map((item) => (
                <HeaderItem
                  onClick={() => !(item.path === '/') && goToLink(item.path)}
                  // disabled={+Boolean(item.path !== '/jobs')}
                  key={item.label}
                  primary={+Boolean(item.path === '/')}
                >
                  {item.label}
                </HeaderItem>
              ))}
            </ButtonCont>
          </Hidden>
          <Hidden mdUp>
            <IconButton>
              <IoReorderThreeSharp color="white" size={30} />
            </IconButton>
          </Hidden>
        </React.Fragment>
      </MainHeader>
      <Hidden smDown>
        <TextCont shrink={shrink ? 1 : 0}>
          <JobText>Noticeboard</JobText>
          <CustomTypography variant="h6" style={{ color: 'white' }}>
            Opportunities listed are accepting submissions from Freelance talent and the public. Feel free to submit
            yourself or share the project/roles with anyone else you feel may be suitable.
          </CustomTypography>
        </TextCont>
      </Hidden>
    </HeaderCont>
  );
};

export default JobsHeader;
